<template>
  <div class="output">
    <table
      border="0"
      cellpadding="0"
      cellspacing="0"
      class="sig"
      style="border-collapse: collapse; font-family: Arial, Helvetica, sans-serif; background-color: #051E39; border-radius: 20px; line-height: 0;"
      width="600"
    >
      <tr>
        <!-- Left - Photo -->
        <td width="175" height="218" style="height:218px; border-collapse: collapse;">
          <img
            :src="data.employee.image"
            alt="Employee Photo"
            width="175"
            height="218"
            style="display: block; border: 0; height: auto; border-radius: 20px 0 0 20px;"
          />
        </td>

        <!-- Spacer -->
        <td width="16" style="font-size: 1px; line-height: 1px;">&nbsp;</td>

        <!-- Right content -->
        <td width="385" valign="top" style="border-collapse: collapse;">
          <table border="0" cellpadding="0" cellspacing="0" width="100%">
            <!-- Spacer -->
            <tr>
              <td width="20" height="16" style="font-size: 1px; line-height: 1px;">&nbsp;</td>
            </tr>

            <tr>
              <td>
                <h3
                  style="margin: 0; padding: 0; font-size: 20px; color: #0099D0; font-weight: bold; line-height: 24px;"
                >
                  {{ data.employee.name }}
                </h3>
              </td>
              <td width="36" align="right" valign="top">
                <img
                  :src="`${publicPath}assets/43CN-logo.png`"
                  alt="43 Clicks North Logo"
                  width="36"
                  height="36"
                  style="display: block; border: 0;"
                />
              </td>
            </tr>

            <tr>
              <td>
                <span style="margin: 0; padding: 0; color: #f8f8f8 !important; -webkit-text-fill-color: #f8f8f8 !important; font-size: 14px; line-height: 16px;">
                  {{ data.employee.role }}
                </span>
              </td>
            </tr>

            <tr>
              <td height="4" style="font-size: 4px; line-height: 4px;">&nbsp;</td>
            </tr>

            <tr>
              <td>
                <span style="margin: 0; padding: 0; color: #f8f8f8 !important; -webkit-text-fill-color: #f8f8f8 !important; font-size: 14px; line-height: 16px;">
                  43 Clicks North Ltd
                </span>
              </td>
            </tr>

            <tr>
              <td height="16" style="font-size: 1px; line-height: 1px;">&nbsp;</td>
            </tr>

            <!-- Contact lines -->
            <tr>
              <td>
                <table border="0" cellpadding="0" cellspacing="0">
                  <tr>
                    <td width="12" valign="middle">
                      <img
                        :src="`${publicPath}assets/phone.png`"
                        width="12"
                        height="auto"
                        alt="Phone"
                        style="display: block; border: 0;"
                      />
                    </td>
                    <td width="8">&nbsp;</td>
                    <td>
                      <a
                        :href="`tel:${data.employee.phone}`"
                        style="color: #f8f8f8; font-size: 14px; text-decoration: none;"
                      >
                        {{ data.employee.phone }}
                      </a>
                    </td>
                  </tr>

                  <tr><td height="10" style="font-size:10px;line-height:10px;">&nbsp;</td></tr>

                  <tr>
                    <td width="12" valign="middle">
                      <img
                        :src="`${publicPath}assets/email.png`"
                        width="12"
                        height="auto"
                        alt="Email"
                        style="display: block; border: 0;"
                      />
                    </td>
                    <td width="8">&nbsp;</td>
                    <td>
                      <a
                        :href="`mailto:${data.employee.email}`"
                        style="color: #f8f8f8; font-size: 14px; text-decoration: none;"
                      >
                        {{ data.employee.email }}
                      </a>
                    </td>
                  </tr>

                  <tr><td height="10" style="font-size:10px;line-height:10px;">&nbsp;</td></tr>

                  <tr>
                    <td width="12" valign="middle" align="middle">
                      <img
                        :src="`${publicPath}assets/link.png`"
                        width="8"
                        height="auto"
                        alt="Website"
                        style="display: block; border: 0;"
                      />
                    </td>
                    <td width="8">&nbsp;</td>
                    <td>
                      <a
                        href="https://www.43clicksnorth.co.uk/"
                        style="color: #f8f8f8; font-size: 14px; text-decoration: none;"
                        target="_blank"
                      >
                        43clicksnorth.co.uk
                      </a>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td height="16" style="font-size: 1px; line-height: 1px;">&nbsp;</td>
            </tr>

            <!-- Social Icons -->
            <tr>
              <td>
                <a
                  :href="data.twitter || 'https://twitter.com/43clicksnorth'"
                  target="_blank"
                  style="display: inline-block; vertical-align: middle;"
                >
                  <img
                    :src="`${publicPath}assets/twitter.png`"
                    width="24"
                    height="24"
                    alt="Twitter"
                    style="display: block; border: 0;"
                  />
                </a>

                <span style="display: inline-block; width: 12px;">&nbsp;</span>

                <a
                  :href="data.linkedin || 'https://www.linkedin.com/company/43-clicks-north'"
                  target="_blank"
                  style="display: inline-block; vertical-align: middle;"
                >
                  <img
                    :src="`${publicPath}assets/linkedin.png`"
                    width="24"
                    height="24"
                    alt="LinkedIn"
                    style="display: block; border: 0;"
                  />
                </a>
              </td>
            </tr>

            <!-- Spacer -->
            <tr>
              <td width="20" height="16" style="font-size: 1px; line-height: 1px;">&nbsp;</td>
            </tr>
          </table>
        </td>

        <!-- Spacer -->
        <td width="16" style="font-size: 1px; line-height: 1px;">&nbsp;</td>
      </tr>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'Output',
    props: ['data', 'publicPath']
  }
</script>
